'use client';

import { useContentSize } from '@/components/SizeProvider';

export default function FooterDesktop() {
  const { width: widthContent, height: heightContent } = useContentSize();
  const lineWidth = `${widthContent * 0.465}px`;

  const _renderGif = () => {
    return (
      <div
        className={'gif-image'}
      >
        <img 
          src="/assets/gif/FLOATINGMAN.gif" 
          alt="Floating Man" 
          width={1000}
          height={1000}
          style={{ width: '52%', height: 'auto' }}
        />
      </div>
    )
  };

  return (
    <footer
      className='footer-desktop-container'
      style={{
        height: heightContent / 10,
      }}
    >
      <div className="footer-info-container"
        style={{
          width: widthContent,
        }}>
        <div className={'footer-info-copyright'}>
          <p className="text-footer">CONCOCTING CHAOS</p>
          <p className="text-footer">TRUST THE PROCESS</p>
        </div>
        <div className="line-footer"
          style={{
            width: lineWidth
          }} 
        />
        {_renderGif()}
        <div className="line-footer"
          style={{
            width: lineWidth
          }} 
        />
      </div>
    </footer>
  )
}
